export default "__VITE_ASSET__B0WZRYJ1__"